module.exports = __webpack_public_path__ + "static/pericia-judicial-logo-aa8df7c338fd53a82117a4d6ceb42de9.png";